import { Injectable } from '@angular/core';
import { BusinessUnitService } from './business-unit.service';
import { AccessRightService } from '@fi-shared/fi-shared-services/access-right.service';
import { DataFieldGroupModel } from '@fi-app/data-field/data-field-group-model';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';

@Injectable()
export class BusinessUnitResolverService {
    constructor(
        private businessUnitService: BusinessUnitService,
        private accessRightService: AccessRightService,
        private userDataService: FiUserDataService,
    ) {}

    ResolveBusinessUnitLightWeightClusters() {
        return this.accessRightService.GetClustersForBusinessUnit();
    }

    ResolveBusinessUnitLightWeightBusinessAreas() {
        return this.accessRightService.GetBusinessAreasForBusinessUnit();
    }

    ResolveBusinessUnitLightWeightAreas() {
        return this.accessRightService.GetAreasForBusinessUnit();
    }

    ResolveBusinessUnitDataFields(dataFieldGroup: DataFieldGroupModel): DataFieldModel[] {
        return dataFieldGroup.DataFields.filter((item) => {
            return item.IsEnabled;
        });
    }
}
